import React from 'react';
import cn from 'classnames';

import './RsTableToolbar.scss';

function RsTableToolbar({ children, className }) {
  return <div className={cn('rs-table-toolbar', className)}>{children}</div>;
}

export default RsTableToolbar;
